module.exports = __webpack_public_path__ + "media/images/lb/041-e30b0f2b7caadbd059500d8abd16c040.svg";